import { buildHelpTicketHref } from '@/lib/help/help-ticket-contract';

type HelpTicketQuietExitsProps = {
  subject: string;
  articleIds?: readonly string[];
  path?: string | null;
  tone?: 'page' | 'chat';
};

export function HelpTicketQuietExits({
  subject,
  articleIds,
  path,
  tone = 'page',
}: HelpTicketQuietExitsProps) {
  const linkClass =
    tone === 'chat'
      ? 'inline-flex items-center gap-1 font-body text-[10px] text-slate-400 transition-interactive duration-200 hover:text-statura-green-accessible'
      : 'inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors';

  return (
    <>
      <a
        href={buildHelpTicketHref({
          category: 'HOW_TO',
          subject,
          articleIds,
          path,
          continuedAfterHelp: true,
        })}
        className={linkClass}
      >
        Didn’t solve it?
      </a>
      <a
        href={buildHelpTicketHref({
          category: 'BUG_REPORT',
          subject,
          articleIds,
          path,
        })}
        className={linkClass}
      >
        Report a bug
      </a>
      <a
        href={buildHelpTicketHref({
          category: 'FEATURE_REQUEST',
          subject,
          articleIds,
          path,
        })}
        className={linkClass}
      >
        Suggest a feature
      </a>
    </>
  );
}
